import React from 'react'
import { Layout } from 'antd'
import { connect } from 'react-redux'

import classNames from 'classnames'

import Sidebar from 'components/cleanui/layout/Sidebar'

import { useTranslation } from 'react-i18next'
import styles from './style.module.scss'

const mapStateToProps = ({ settings, menu }) => ({
  disableCreate: menu.disableCreate,
  isContentMaxWidth: settings.isContentMaxWidth,
  isAppMaxWidth: settings.isAppMaxWidth,
  isGrayBackground: settings.isGrayBackground,
  isSquaredBorders: settings.isSquaredBorders,
  isCardShadow: settings.isCardShadow,
  isBorderless: settings.isBorderless,
  isTopbarFixed: settings.isTopbarFixed,
  isGrayTopbar: settings.isGrayTopbar,
})

const MainLayout = ({
  children,
  isContentMaxWidth,
  isAppMaxWidth,
  isGrayBackground,
  isSquaredBorders,
  isCardShadow,
  isBorderless,
}) => {
  const { t } = useTranslation()

  return (
    <div className={classNames('officemail', { cui__layout__grayBackground: isGrayBackground })}>
      <Layout
        className={classNames({
          cui__layout__contentMaxWidth: isContentMaxWidth,
          cui__layout__appMaxWidth: isAppMaxWidth,
          cui__layout__grayBackground: isGrayBackground,
          cui__layout__squaredBorders: isSquaredBorders,
          cui__layout__cardsShadow: isCardShadow,
          cui__layout__borderless: isBorderless,
        })}
      >
        <React.Suspense fallback={<div>{t('common.title.loading')}</div>} />
        <Layout.Content className={classNames(styles.mainFrame)}>
          <Layout>
            <Sidebar />
            <Layout>
              <Layout.Content style={{ height: '100%', position: 'relative' }}>
                <div className={classNames(styles.content)}>{children}</div>
              </Layout.Content>
            </Layout>
          </Layout>
        </Layout.Content>
      </Layout>
    </div>
  )
}

export default connect(mapStateToProps)(MainLayout)
